import React, { useEffect, useState, useMemo } from 'react';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import AccommodationDetails from './AccommodationDetails';
import Button from '../../shared/components/ui/Button';
import SaleOverview from './SaleOverview';
import { STAGE_HISTORY_AND_LOGS_TAB } from '../constants/leadDetailTabs';
import DealsDetails from './DealsDetails';
import ScheduleDetails from './ScheduleDetails';
import ActivityList from './ActivityList';
import SaleAttachmentList from './SaleAttachmentList';
import { useLocation, useParams } from 'react-router-dom';
import { useSmartBack } from '../../shared/navigation';
import { useQuery, useMutation } from '@tanstack/react-query';
import {
  getLeadByID,
  getCloseDealsByLeadId,
  uploadCloseDealAgreementLetter,
  addCloseDealLoanDetails,
  getCloseDealLoanDetails,
  approveCloseDealLoanDetails,
  downloadCloseDealAgreementLetter,
  uploadFilesToS3
} from '../services/api/implementation/impl';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Logs from './Logs';
import DealsList from './DealsList';
import PostSalesDealHub from '../components/postSales/PostSalesDealHub';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import uploadIcon from '../../shared/assets/svg/upload.svg';
import downloadIcon from '../../shared/assets/svg/download-s.svg';
import { Download, Upload } from 'lucide-react';
import Modal from '../../shared/components/ui/Modal';
import FormInput from '../../shared/components/ui/FormInput';
import { useForm, Controller } from 'react-hook-form';
import toast from 'react-hot-toast';
import Multiselect from 'multiselect-react-dropdown';

// List of major Indian banks (same as AddChequeForm)
const INDIAN_BANKS = [
  // Public Sector Banks
  { id: 'State Bank of India', value: 'State Bank of India', label: 'State Bank of India' },
  { id: 'Punjab National Bank', value: 'Punjab National Bank', label: 'Punjab National Bank' },
  { id: 'Bank of Baroda', value: 'Bank of Baroda', label: 'Bank of Baroda' },
  { id: 'Canara Bank', value: 'Canara Bank', label: 'Canara Bank' },
  { id: 'Union Bank of India', value: 'Union Bank of India', label: 'Union Bank of India' },
  { id: 'Bank of India', value: 'Bank of India', label: 'Bank of India' },
  { id: 'Central Bank of India', value: 'Central Bank of India', label: 'Central Bank of India' },
  { id: 'Indian Bank', value: 'Indian Bank', label: 'Indian Bank' },
  { id: 'Indian Overseas Bank', value: 'Indian Overseas Bank', label: 'Indian Overseas Bank' },
  { id: 'UCO Bank', value: 'UCO Bank', label: 'UCO Bank' },
  { id: 'Bank of Maharashtra', value: 'Bank of Maharashtra', label: 'Bank of Maharashtra' },
  { id: 'Punjab & Sind Bank', value: 'Punjab & Sind Bank', label: 'Punjab & Sind Bank' },

  // Private Sector Banks - Large
  { id: 'HDFC Bank', value: 'HDFC Bank', label: 'HDFC Bank' },
  { id: 'ICICI Bank', value: 'ICICI Bank', label: 'ICICI Bank' },
  { id: 'Axis Bank', value: 'Axis Bank', label: 'Axis Bank' },
  { id: 'Kotak Mahindra Bank', value: 'Kotak Mahindra Bank', label: 'Kotak Mahindra Bank' },
  { id: 'IndusInd Bank', value: 'IndusInd Bank', label: 'IndusInd Bank' },
  { id: 'Yes Bank', value: 'Yes Bank', label: 'Yes Bank' },
  { id: 'IDFC First Bank', value: 'IDFC First Bank', label: 'IDFC First Bank' },
  { id: 'Federal Bank', value: 'Federal Bank', label: 'Federal Bank' },
  { id: 'RBL Bank', value: 'RBL Bank', label: 'RBL Bank' },
  { id: 'South Indian Bank', value: 'South Indian Bank', label: 'South Indian Bank' },
  { id: 'Karnataka Bank', value: 'Karnataka Bank', label: 'Karnataka Bank' },
  { id: 'City Union Bank', value: 'City Union Bank', label: 'City Union Bank' },
  { id: 'DCB Bank', value: 'DCB Bank', label: 'DCB Bank' },
  { id: 'Jammu & Kashmir Bank', value: 'Jammu & Kashmir Bank', label: 'Jammu & Kashmir Bank' },
  { id: 'IDBI Bank', value: 'IDBI Bank', label: 'IDBI Bank' },
  { id: 'Bandhan Bank', value: 'Bandhan Bank', label: 'Bandhan Bank' },
  { id: 'Karur Vysya Bank', value: 'Karur Vysya Bank', label: 'Karur Vysya Bank' },
  {
    id: 'Tamilnad Mercantile Bank',
    value: 'Tamilnad Mercantile Bank',
    label: 'Tamilnad Mercantile Bank'
  },
  { id: 'Nainital Bank', value: 'Nainital Bank', label: 'Nainital Bank' },
  { id: 'Catholic Syrian Bank', value: 'Catholic Syrian Bank', label: 'Catholic Syrian Bank' },
  { id: 'Dhanlaxmi Bank', value: 'Dhanlaxmi Bank', label: 'Dhanlaxmi Bank' },

  // Small Finance Banks
  { id: 'AU Small Finance Bank', value: 'AU Small Finance Bank', label: 'AU Small Finance Bank' },
  {
    id: 'Equitas Small Finance Bank',
    value: 'Equitas Small Finance Bank',
    label: 'Equitas Small Finance Bank'
  },
  {
    id: 'Ujjivan Small Finance Bank',
    value: 'Ujjivan Small Finance Bank',
    label: 'Ujjivan Small Finance Bank'
  },
  {
    id: 'Suryoday Small Finance Bank',
    value: 'Suryoday Small Finance Bank',
    label: 'Suryoday Small Finance Bank'
  },
  {
    id: 'Jana Small Finance Bank',
    value: 'Jana Small Finance Bank',
    label: 'Jana Small Finance Bank'
  },
  {
    id: 'Fincare Small Finance Bank',
    value: 'Fincare Small Finance Bank',
    label: 'Fincare Small Finance Bank'
  },
  {
    id: 'North East Small Finance Bank',
    value: 'North East Small Finance Bank',
    label: 'North East Small Finance Bank'
  },
  {
    id: 'Capital Small Finance Bank',
    value: 'Capital Small Finance Bank',
    label: 'Capital Small Finance Bank'
  },
  {
    id: 'ESAF Small Finance Bank',
    value: 'ESAF Small Finance Bank',
    label: 'ESAF Small Finance Bank'
  },
  {
    id: 'Utkarsh Small Finance Bank',
    value: 'Utkarsh Small Finance Bank',
    label: 'Utkarsh Small Finance Bank'
  },
  {
    id: 'Shivalik Small Finance Bank',
    value: 'Shivalik Small Finance Bank',
    label: 'Shivalik Small Finance Bank'
  },
  {
    id: 'Unity Small Finance Bank',
    value: 'Unity Small Finance Bank',
    label: 'Unity Small Finance Bank'
  },

  // Payment Banks
  { id: 'Paytm Payments Bank', value: 'Paytm Payments Bank', label: 'Paytm Payments Bank' },
  {
    id: 'India Post Payments Bank',
    value: 'India Post Payments Bank',
    label: 'India Post Payments Bank'
  },
  { id: 'Airtel Payments Bank', value: 'Airtel Payments Bank', label: 'Airtel Payments Bank' },
  { id: 'Fino Payments Bank', value: 'Fino Payments Bank', label: 'Fino Payments Bank' },
  { id: 'Jio Payments Bank', value: 'Jio Payments Bank', label: 'Jio Payments Bank' },
  { id: 'NSDL Payments Bank', value: 'NSDL Payments Bank', label: 'NSDL Payments Bank' },

  // Foreign Banks
  { id: 'Citibank', value: 'Citibank', label: 'Citibank' },
  { id: 'HSBC Bank', value: 'HSBC Bank', label: 'HSBC Bank' },
  {
    id: 'Standard Chartered Bank',
    value: 'Standard Chartered Bank',
    label: 'Standard Chartered Bank'
  },
  { id: 'Deutsche Bank', value: 'Deutsche Bank', label: 'Deutsche Bank' },
  { id: 'Barclays Bank', value: 'Barclays Bank', label: 'Barclays Bank' },
  {
    id: 'American Express Banking Corp',
    value: 'American Express Banking Corp',
    label: 'American Express Banking Corp'
  },
  { id: 'DBS Bank India', value: 'DBS Bank India', label: 'DBS Bank India' },
  { id: 'Bank of America', value: 'Bank of America', label: 'Bank of America' },
  { id: 'JPMorgan Chase Bank', value: 'JPMorgan Chase Bank', label: 'JPMorgan Chase Bank' },
  { id: 'BNP Paribas', value: 'BNP Paribas', label: 'BNP Paribas' },
  { id: 'Mizuho Bank', value: 'Mizuho Bank', label: 'Mizuho Bank' },
  {
    id: 'Sumitomo Mitsui Banking Corporation',
    value: 'Sumitomo Mitsui Banking Corporation',
    label: 'Sumitomo Mitsui Banking Corporation'
  },
  { id: 'Bank of China', value: 'Bank of China', label: 'Bank of China' },
  {
    id: 'Credit Agricole Corporate and Investment Bank',
    value: 'Credit Agricole Corporate and Investment Bank',
    label: 'Credit Agricole Corporate and Investment Bank'
  },
  { id: 'FirstRand Bank', value: 'FirstRand Bank', label: 'FirstRand Bank' },
  { id: 'Societe Generale', value: 'Societe Generale', label: 'Societe Generale' },
  {
    id: 'Royal Bank of Scotland',
    value: 'Royal Bank of Scotland',
    label: 'Royal Bank of Scotland'
  },
  { id: 'UBS AG', value: 'UBS AG', label: 'UBS AG' },
  { id: 'Credit Suisse', value: 'Credit Suisse', label: 'Credit Suisse' },
  {
    id: 'Industrial and Commercial Bank of China',
    value: 'Industrial and Commercial Bank of China',
    label: 'Industrial and Commercial Bank of China'
  },
  { id: 'Mashreq Bank', value: 'Mashreq Bank', label: 'Mashreq Bank' },
  { id: 'Doha Bank', value: 'Doha Bank', label: 'Doha Bank' },
  { id: 'Sberbank', value: 'Sberbank', label: 'Sberbank' },
  { id: 'Shinhan Bank', value: 'Shinhan Bank', label: 'Shinhan Bank' },
  { id: 'KEB Hana Bank', value: 'KEB Hana Bank', label: 'KEB Hana Bank' },
  { id: 'Woori Bank', value: 'Woori Bank', label: 'Woori Bank' },
  {
    id: 'China Construction Bank',
    value: 'China Construction Bank',
    label: 'China Construction Bank'
  },
  {
    id: 'Rabobank International',
    value: 'Rabobank International',
    label: 'Rabobank International'
  },
  {
    id: 'Australia and New Zealand Banking Group',
    value: 'Australia and New Zealand Banking Group',
    label: 'Australia and New Zealand Banking Group'
  },
  { id: 'Scotiabank', value: 'Scotiabank', label: 'Scotiabank' },
  {
    id: 'National Australia Bank',
    value: 'National Australia Bank',
    label: 'National Australia Bank'
  },
  {
    id: 'Westpac Banking Corporation',
    value: 'Westpac Banking Corporation',
    label: 'Westpac Banking Corporation'
  },
  {
    id: 'Commonwealth Bank of Australia',
    value: 'Commonwealth Bank of Australia',
    label: 'Commonwealth Bank of Australia'
  },
  { id: 'United Overseas Bank', value: 'United Overseas Bank', label: 'United Overseas Bank' },
  { id: 'CTBC Bank', value: 'CTBC Bank', label: 'CTBC Bank' },
  { id: 'MUFG Bank', value: 'MUFG Bank', label: 'MUFG Bank' },

  // Other
  { id: 'Other', value: 'Other', label: 'Other' }
].sort();

const ClosedDealDetails = () => {
  const userId = Cookies.get('userId');
  const { id } = useParams();
  const { collapsed } = useSidebar();
  const { status } = useLocation().state || {};
  const { onBack } = useSmartBack({ fallback: '/builder/sales/deals' });

  // Fetch deal data to check isLoanBased and files
  const {
    data: dealsData,
    isLoading: isLoadingDeals,
    refetch: refetchDeals
  } = useQuery({
    queryKey: ['closedDeals', id],
    queryFn: () => getCloseDealsByLeadId(id),
    enabled: !!id,
    refetchOnWindowFocus: true
  });

  // Get the deal for current lead (Pending or Approved)
  const currentDeal = useMemo(() => {
    if (!dealsData?.data || !id) return null;
    const leadId = parseInt(id, 10);
    const rows = Array.isArray(dealsData.data) ? dealsData.data : [dealsData.data];
    return rows.find((deal) => deal.lead_id === leadId) ?? rows[0] ?? null;
  }, [dealsData?.data, id]);

  /* 
    Local state
  */
  const [secondaryTab, setSecondaryTab] = useState('Overview');
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showLoanDetailsModal, setShowLoanDetailsModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFileData, setUploadedFileData] = useState(null);
  const [isUploadingFile, setIsUploadingFile] = useState(false);

  // Form for upload agreement
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
    control
  } = useForm();

  const paymentType = watch('paymentType');
  const bankNames = watch('bankNames') || [];
  const customBankName = watch('customBankName');

  // API Query for Loan Details
  const {
    data: loanDetailsData,
    isLoading: isLoadingLoanDetails,
    refetch: refetchLoanDetails
  } = useQuery({
    queryKey: ['loanDetails', currentDeal?.id],
    queryFn: () => getCloseDealLoanDetails(currentDeal?.id),
    enabled: !!currentDeal?.id && showLoanDetailsModal
  });

  // Mutation for adding loan details (must be defined before uploadAgreement)
  const addLoanDetailsMutation = useMutation({
    mutationFn: (payload) => addCloseDealLoanDetails(payload),
    onSuccess: () => {
      toast.success('Agreement and loan details saved successfully');
      setShowUploadModal(false);
      reset();
      setSelectedFile(null);
      setUploadedFileData(null);
      refetchDeals();
      mixpanel.track('Loan Details Added Successfully', {
        user_id: userId,
        deal_id: currentDeal?.id,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to add loan details');
      mixpanel.track('Loan Details Failed', {
        user_id: userId,
        deal_id: currentDeal?.id,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  // Mutation for uploading agreement
  const { mutate: uploadAgreement, isPending: isSubmittingAgreement } = useMutation({
    mutationFn: async ({ dealId, filePayload }) => {
      return await uploadCloseDealAgreementLetter(dealId, filePayload);
    },
    onSuccess: async (_, variables) => {
      // If payment type is loan based, call add loan details
      if (variables.paymentType === 'loan') {
        await addLoanDetailsMutation.mutateAsync({
          deal_id: variables.dealId,
          bankNames: variables.bankNames || [] // Array of bank names
        });
      } else {
        // If self, just close modal and refetch
        toast.success('Agreement uploaded successfully');
        setShowUploadModal(false);
        reset();
        setSelectedFile(null);
        setUploadedFileData(null);
        refetchDeals();
        mixpanel.track('Agreement Uploaded Successfully', {
          user_id: userId,
          deal_id: variables.dealId,
          payment_type: variables.paymentType,
          timestamp: new Date().toISOString()
        });
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to upload agreement');
      mixpanel.track('Agreement Upload Failed', {
        user_id: userId,
        deal_id: currentDeal?.id,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  // Mutation for approving loan
  const { mutate: approveLoan, isPending: isApprovingLoan } = useMutation({
    mutationFn: ({ loanId }) =>
      approveCloseDealLoanDetails(loanId, {
        status: 'Approved',
        approved: true
      }),
    onSuccess: () => {
      toast.success('Loan Accepted successfully');
      refetchLoanDetails();
      refetchDeals();
      setShowLoanDetailsModal(false);
      mixpanel.track('Loan Approved', {
        user_id: userId,
        deal_id: currentDeal?.id,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to approve loan');
      mixpanel.track('Loan Approval Failed', {
        user_id: userId,
        deal_id: currentDeal?.id,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  // Mutation for downloading agreement
  const { mutate: downloadAgreement, isPending: isDownloadingAgreement } = useMutation({
    mutationFn: (dealId) => downloadCloseDealAgreementLetter(dealId),
    onSuccess: (data, dealId) => {
      const fileName = currentDeal?.files?.[0]?.name || `agreement-letter-${dealId}.pdf`;
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast.success('Agreement downloaded successfully');
      mixpanel.track('Download Agreement Clicked', {
        user_id: userId,
        deal_id: dealId,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message || error?.message || 'Failed to download agreement'
      );
      mixpanel.track('Download Agreement Failed', {
        user_id: userId,
        deal_id: currentDeal?.id,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  // Handle file selection
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setIsUploadingFile(true);

    try {
      // Upload file to S3
      const uploadedFiles = await uploadFilesToS3([file]);
      if (uploadedFiles && uploadedFiles.length > 0) {
        setUploadedFileData({
          name: uploadedFiles[0].name,
          url: uploadedFiles[0].url
        });
        toast.success('File uploaded successfully');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.error('Failed to upload file');
      setSelectedFile(null);
      setUploadedFileData(null);
    } finally {
      setIsUploadingFile(false);
    }
  };

  // Handle upload agreement form submission
  const onSubmitAgreement = async (data) => {
    if (!uploadedFileData) {
      toast.error('Please upload an agreement file');
      return;
    }

    if (!currentDeal?.id) {
      toast.error('Deal ID not found');
      return;
    }

    const filePayload = {
      file: {
        name: uploadedFileData.name,
        url: uploadedFileData.url
      }
    };

    // Upload agreement first
    // Process bank names: if "Other" is selected, replace it with customBankName
    const processedBankNames = (data.bankNames || []).map((bank) => {
      if (
        bank === 'Other' ||
        bank?.value === 'Other' ||
        bank?.id === 'Other' ||
        bank?.name === 'Other'
      ) {
        return data.customBankName;
      }
      return typeof bank === 'string' ? bank : bank?.value || bank?.name || bank?.id || bank;
    });

    uploadAgreement({
      dealId: currentDeal.id,
      filePayload,
      paymentType: data.paymentType,
      bankNames: processedBankNames
    });
  };

  // Handlers for buttons
  const handleUploadAgreement = () => {
    setShowUploadModal(true);
    mixpanel.track('Upload Agreement Clicked', {
      user_id: userId,
      deal_id: id,
      timestamp: new Date().toISOString()
    });
  };

  const handleDownloadAgreement = () => {
    if (!currentDeal?.id) {
      toast.error('Deal ID not found');
      return;
    }
    downloadAgreement(currentDeal.id);
  };

  const handleLoanDetails = () => {
    setShowLoanDetailsModal(true);
    mixpanel.track('Loan Details Clicked', {
      user_id: userId,
      deal_id: id,
      timestamp: new Date().toISOString()
    });
  };

  /* 
    JSX
  */
  return (
    <>
      {/* Main content */}
      <Layout>
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header
            data={{ name: `Sales > ${status || 'Unknown'}` }}
            backArrow={true}
            onBack={onBack}
          />
        </div>

        {/* Secondary Tabbed content */}
        <div
          className={` ${collapsed ? 'w-[100%] pl-3' : 'w-[100%]'} flex flex-col justify-start items-center mt-[4rem]`}>
          <SaleOverview
            leadID={id}
            type="deal"
            combineHistoryAndLogsTabs
            activeHeaderTab={secondaryTab}
            onHeaderTabChange={(tab) => {
              mixpanel.track('Closed Deal Details Tab Changed', {
                user_id: userId,
                lead_id: id,
                tab: tab,
                timestamp: new Date().toISOString()
              });
              setSecondaryTab(tab);
            }}
            dealPricingDetailsToolbar={
              currentDeal?.status !== 'Pending' &&
              currentDeal?.status !== 'Cancelled' && (
                <div className="w-full max-w-[1500px] flex flex-wrap justify-end items-center gap-3 py-3 border-b border-gray-200 mb-2">
                  {(!currentDeal?.files || currentDeal?.files?.length === 0) && (
                    <Button
                      onClick={handleUploadAgreement}
                      customStyle={{
                        padding: '0.5rem 1rem',
                        fontSize: '13px',
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center'
                      }}
                      displayType={'downloadButton'}>
                      <Upload size={16} />
                      Agreement Letter
                    </Button>
                  )}

                  {currentDeal?.files && currentDeal?.files?.length > 0 && (
                    <Button
                      onClick={handleDownloadAgreement}
                      customStyle={{
                        padding: '0.5rem 1rem',
                        fontSize: '13px',
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center'
                      }}
                      displayType={'downloadButton'}>
                      <Download size={16} />
                      Agreement Letter
                    </Button>
                  )}

                  {currentDeal?.isLoanBased && (
                    <Button
                      onClick={handleLoanDetails}
                      customStyle={{
                        padding: '0.5rem 1rem',
                        fontSize: '13px'
                      }}
                      displayType={'downloadButton'}>
                      Loan Details
                    </Button>
                  )}
                </div>
              )
            }
          />
        </div>

        <div
          className={` ${collapsed ? 'w-[100%] pl-7 pr-4' : 'w-[100%] pl-4 pr-4'} flex flex-col justify-start items-stretch `}>
          {secondaryTab === STAGE_HISTORY_AND_LOGS_TAB && (
            <div className="flex w-full min-w-0 flex-col gap-4 lg:flex-row lg:items-stretch">
              <div className="flex min-h-0 min-w-0 flex-1 basis-0 flex-col lg:w-1/2">
                <DealsList
                  salesId={id ? parseInt(id) : undefined}
                  dealData={currentDeal}
                  isLoadingDeals={isLoadingDeals}
                  onDealUpdate={refetchDeals}
                  variant="split"
                />
              </div>
              <div className="flex min-h-0 min-w-0 flex-1 basis-0 flex-col lg:w-1/2">
                <Logs salesId={id ? parseInt(id) : undefined} variant="split" />
              </div>
            </div>
          )}

          {secondaryTab === 'Post Sales' &&
            (currentDeal?.id ? (
              <PostSalesDealHub
                deal={currentDeal}
                lead={currentDeal?.lead}
                onDealUpdate={refetchDeals}
              />
            ) : (
              <div className="mt-2 flex min-h-[10rem] items-center justify-center rounded-2xl border border-slate-200/90 bg-white text-sm text-slate-500">
                {isLoadingDeals ? 'Loading deal…' : 'No closed deal found for this lead.'}
              </div>
            ))}
        </div>
      </Layout>

      {/* Upload Agreement Modal */}
      {showUploadModal && (
        <Modal
          name="Upload Agreement Letter"
          width={50}
          onClose={() => {
            setShowUploadModal(false);
            reset();
            setSelectedFile(null);
            setUploadedFileData(null);
          }}>
          <form onSubmit={handleSubmit(onSubmitAgreement)} className="p-6">
            <div className="space-y-4">
              {/* File Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Agreement File <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  disabled={isUploadingFile}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {isUploadingFile && <p className="text-sm text-gray-500 mt-1">Uploading file...</p>}
                {uploadedFileData && (
                  <p className="text-sm text-green-600 mt-1">
                    ✓ File uploaded: {uploadedFileData.name}
                  </p>
                )}
                {errors.file && <p className="text-sm text-red-500 mt-1">{errors.file.message}</p>}
              </div>

              {/* Payment Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Payment Type <span className="text-red-500">*</span>
                </label>
                <select
                  {...register('paymentType', { required: 'Payment type is required' })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="">Select payment type</option>
                  <option value="self">Self</option>
                  <option value="loan">Loan Based</option>
                </select>
                {errors.paymentType && (
                  <p className="text-sm text-red-500 mt-1">{errors.paymentType.message}</p>
                )}
              </div>

              {/* Loan Based Fields */}
              {paymentType === 'loan' && (
                <>
                  <Controller
                    name="bankNames"
                    control={control}
                    rules={{
                      required: 'At least one banking partner is required',
                      validate: (value) => {
                        if (!value || !Array.isArray(value) || value.length === 0) {
                          return 'At least one banking partner is required';
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState }) => (
                      <div className="flex-shrink-0 flex flex-col gap-2 text-gray-600">
                        <div className="flex justify-between items-start space-x-2 w-fit">
                          <span className="text-gray-600">Banking Partner</span>
                          <span className="text-red-500">*</span>
                        </div>
                        <Multiselect
                          options={INDIAN_BANKS.map((bank) => ({
                            id: bank.id,
                            name: bank.label
                          }))}
                          selectedValues={field.value || []}
                          onSelect={(selectedList) => {
                            field.onChange(selectedList);
                            // Reset custom bank name if "Other" is not in the selection
                            const hasOther = selectedList.some(
                              (item) =>
                                item === 'Other' ||
                                item.id === 'Other' ||
                                item.value === 'Other' ||
                                item.name === 'Other'
                            );
                            if (!hasOther) {
                              reset({ ...watch(), customBankName: '' });
                            }
                          }}
                          onRemove={(selectedList) => {
                            field.onChange(selectedList);
                            // Reset custom bank name if "Other" is not in the selection
                            const hasOther = selectedList.some(
                              (item) =>
                                item === 'Other' ||
                                item.id === 'Other' ||
                                item.value === 'Other' ||
                                item.name === 'Other'
                            );
                            if (!hasOther) {
                              reset({ ...watch(), customBankName: '' });
                            }
                          }}
                          displayValue="name"
                          placeholder="Select banking partners"
                          style={{
                            optionContainer: {
                              border: '1px solid',
                              backgroundColor: 'white'
                            },
                            option: {
                              color: 'black',
                              backgroundColor: 'white'
                            },
                            chips: {
                              background: '#2A565E',
                              color: 'white'
                            }
                          }}
                        />
                        {fieldState.error && (
                          <p className="text-red-500 text-sm mt-1">{fieldState.error.message}</p>
                        )}
                      </div>
                    )}
                  />
                  {bankNames.some(
                    (bank) =>
                      bank === 'Other' ||
                      bank?.id === 'Other' ||
                      bank?.value === 'Other' ||
                      bank?.name === 'Other'
                  ) && (
                    <FormInput
                      width={100}
                      label="Other Banking Partner"
                      register={register}
                      register_key="customBankName"
                      isRequired={true}
                      type="text"
                      validation={{ required: 'Other banking partner name is required' }}
                      errors={errors}
                    />
                  )}
                </>
              )}

              <div className="flex justify-end gap-3 mt-6">
                <Button
                  type="button"
                  displayType={'secondary'}
                  onClick={() => {
                    setShowUploadModal(false);
                    reset();
                    setSelectedFile(null);
                    setUploadedFileData(null);
                  }}
                  className="bg-gray-200 text-gray-700 hover:bg-gray-300">
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={
                    isSubmittingAgreement ||
                    isUploadingFile ||
                    !uploadedFileData ||
                    addLoanDetailsMutation.isPending
                  }>
                  {isSubmittingAgreement || addLoanDetailsMutation.isPending
                    ? 'Submitting...'
                    : 'Submit'}
                </Button>
              </div>
            </div>
          </form>
        </Modal>
      )}

      {/* Loan Details Modal */}
      {showLoanDetailsModal && (
        <Modal
          name="Loan Details"
          width={50}
          onClose={() => {
            setShowLoanDetailsModal(false);
          }}>
          <div>
            {isLoadingLoanDetails ? (
              <div className="flex justify-center items-center h-[10rem]">
                <p className="text-sm text-gray-500">Loading loan details...</p>
              </div>
            ) : loanDetailsData?.data ? (
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Banking Partners
                  </label>
                  <div className="text-sm text-gray-900 bg-gray-50 p-3 rounded-lg">
                    {loanDetailsData?.data?.bankNames &&
                    Array.isArray(loanDetailsData.data.bankNames) &&
                    loanDetailsData.data.bankNames.length > 0 ? (
                      <div className="flex flex-wrap gap-2">
                        {loanDetailsData.data.bankNames.map((bankName, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center px-2 py-1 bg-gray-200 rounded-full text-xs font-medium">
                            {bankName}
                          </span>
                        ))}
                      </div>
                    ) : loanDetailsData?.data?.bankName ? (
                      <span className="inline-flex items-center px-2 py-1 bg-gray-200 rounded-full text-xs font-medium">
                        {loanDetailsData.data.bankName}
                      </span>
                    ) : (
                      'N/A'
                    )}
                  </div>
                </div>
                {loanDetailsData?.data?.approved !== true && (
                  <div className="flex justify-end mt-6">
                    <Button
                      onClick={() =>
                        approveLoan({ loanId: loanDetailsData?.data?.id || currentDeal?.id })
                      }
                      disabled={isApprovingLoan}>
                      {isApprovingLoan ? 'Accepting...' : 'Loan Approved'}
                    </Button>
                  </div>
                )}
                {loanDetailsData?.data?.approved === true && (
                  <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-sm text-green-800 font-medium">✓ Loan Approved</p>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex justify-center items-center h-[10rem]">
                <p className="text-sm text-gray-500">No loan details found</p>
              </div>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default ClosedDealDetails;
